module.exports = __webpack_public_path__ + "static/cdarma@2x-400dfd9e14af0f5f017a8d8d483d55fe.jpg";